import React, { useState, useEffect } from "react";
import Button from "../../components/common/ui/Button";
import { history } from "../../_helpers";
import { DateInput, SelectInput } from "../../components/common/ui/Inputs";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import Table from "../../components/common/table/Table";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { masterActions } from "./../../_store/master.slice";
import Facility from "./../Facility/Facility";
import { inmateAction } from "./../../_store/inmate.slice";
import generateXlsx from "./../../components/common/export/generateXlsx";
import { formatDateTimeAMPM } from "../../utils/formatTime";
import CustomLoader from "../../components/common/ui/Loader";

function InmateFreeCredits() {
  const location = useLocation();
  const { inmate: Inmate } = location.state || {};

  const {
    inmateInfoTabData,
    freeCreditList,
    freeCreditFullList,
    inmate,
    loading,
  } = useSelector((x) => x.inmate);
  const {
    user,
    managementUserAccessPermission,
    commonFacilityCode: facilityCode,
  } = useSelector((x) => x.auth);

  const [freeCredit, setFreeCredit] = useState({
    InmatesId: 0,
    FacilityID: 0,
    PageNo: 1,
    RowCountPerPage: 10,
    // SortField: "InmateFreeCreditDate desc",
    SortField: "",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (!Inmate?.InmateID && !inmate?.InmateID) return;

    let updatedParam = {
      ...freeCredit,
      InmatesId: Inmate?.InmateID || inmate?.InmateID,
      FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
    };

    setFreeCredit(updatedParam);

    dispatch(inmateAction.GetInmateFreeCreditDetails(updatedParam));
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  };

  const columns = [
    {
      name: "Date",
      key: "InmateFreeCreditDate",
      selector: (row) => formatDate(row.InmateFreeCreditDate),
      sortFunction: (a, b) =>
        new Date(a.InmateFreeCreditDate) - new Date(b.InmateFreeCreditDate),
      sortable: true,
    },
    {
      name: "Credit ($)",
      key: "CreditAmount",
      selector: (row) => row.CreditAmount.toFixed(2),
      sortable: true,
    },
    {
      name: "Debit ($)",
      key: "DebitAmount",
      selector: (row) => row.DebitAmount.toFixed(2),
      sortable: true,
    },
    {
      name: "Balance ($)",
      key: "InmateFreeCreditBalance",
      selector: (row) => row.InmateFreeCreditBalance.toFixed(2),
      sortable: true,
    },
  ];

  //Table Pagination
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    if (!initialLoad) {
      dispatch(inmateAction.GetInmateFreeCreditDetails(freeCredit));
    }
  }, [freeCredit.PageNo, freeCredit.RowCountPerPage]);

  const handlePageChange = (pageNo) => {
    if (isSorting) {
      isSorting = false;
      return;
    }

    setInitialLoad(false);
    setFreeCredit((prev) => ({
      ...prev,
      PageNo: pageNo,
    }));
  };

  const handleRowPerPage = (rowCount) => {
    setInitialLoad(false);
    setFreeCredit((prev) => ({
      ...prev,
      PageNo: 1,
      RowCountPerPage: rowCount,
    }));
  };

  let isSorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;

    isSorting = true;
    const search = { ...freeCredit };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    setFreeCredit(search);
    dispatch(
      inmateAction.GetInmateFreeCreditDetails({
        ...freeCredit,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };
  //Export

  useEffect(() => {
    if (freeCreditFullList && freeCreditFullList?.DataList?.length > 0) {
      let title = "FreeCredits_List";
      let generateExcelColumns = [
        "Date",
        "Credit ($)",
        "Debit ($)",
        "Balance($)",
      ];

      // Map the account manager list to match the Excel format
      let PUFreeCredit_List =
        freeCreditFullList?.DataList?.map((obj) => ({
          Date: formatDateTimeAMPM(obj.InmateFreeCreditDate),
          Credit: obj.CreditAmount?.toFixed(2),
          Debit: obj.DebitAmount?.toFixed(2),
          Balance: obj.InmateFreeCreditBalance?.toFixed(2),
        })) || [];

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(PUFreeCredit_List, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(inmateAction.clearfreeCreditFullList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [freeCreditFullList]);

  const handleExcel = () => {
    let updatedParam = {
      ...freeCredit,
      PageNo: 1,
      RowCountPerPage: freeCreditList?.TotalRecordCount,
      exportExcel: true,
    };

    dispatch(inmateAction.GetInmateFreeCreditDetails(updatedParam));
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <div>
      <div className="p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap ">
          <h4 className=" inner-subheader-bg text-color">
            <i className="fa fa-usd" aria-hidden="true"></i> Free Credits
          </h4>
          <Button
            label="Back"
            icon={"fa-solid fa-angle-left"}
            type="button"
            status="primary"
            onClick={() => {
              history.navigate("/Admin/InmateList");
              dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
            }}
          />
        </div>
      </div>
      <div className="card shadow-sm b-r-all p-3 border border-dark-grey mt-1 w-100">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h2 className="text-color form_title_uppercase">Free Credits</h2>
        </div>

        {/* First Row: Username, Last Name, First Name */}
        <div className="row mt-2">
          {[
            {
              label: "Inmate Resident ID",
              value: Inmate?.InmateResidentId || inmate?.InmateResidentId,
            },
            {
              label: "Full Name",
              value:
                Inmate?.InmateFullName ||
                inmate?.InmateFullName ||
                (inmateInfoTabData?.length > 0 &&
                  inmateInfoTabData[0]?.InmateFullName),
            },
            {
              label: "Totally Credited ($)",
              value:
                freeCreditList?.DataList && freeCreditList.DataList.length > 0
                  ? freeCreditList.DataList[0].InmateTotalFreeCreditAmount?.toFixed(2)
                  : "N/A",
            },
            {
              label: "Balance Credits ($)",
              value:
                freeCreditList?.DataList && freeCreditList.DataList.length > 0
                  ? freeCreditList.DataList[0].InmateCurrentFreeCreditAmount?.toFixed(2)
                  : "N/A",
            },
          ].map((item, index) => (
            <div key={index} className="col-sm-6 col-md-6">
              <div className="user-information d-flex  align-items-center">
                <div className="fs-5 p-2 value-info">{item.label}</div>
                <div className="">:</div>
                <div className="fs-5 p-2 text-start fw-bold value-text">
                  {item.value || "-"}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-3">
        <div className="d-flex flex-wrap  justify-content-end mb-3">
          <ExcelExport variant="soft-gray" handleExcelExport={handleExcel} />
        </div>
        {/* Table Section */}

        <Table
          columns={columns}
          data={freeCreditList?.DataList}
          pagination
          onChangePage={handlePageChange} // Call API when page changes
          onChangeRowsPerPage={handleRowPerPage}
          totalRowCount={freeCreditList?.TotalRecordCount}
          currentPage={freeCredit?.PageNo}
          paginationPerPage={freeCredit?.RowCountPerPage}
          serverSideSort
          onSort={handleSort}
          sortColumn={freeCredit?.SortField.split(" ")[0]}
          sortDirection={freeCredit?.SortField.split(" ")[1]}
        />
      </div>
    </div>
  );
}

export default React.memo(InmateFreeCredits);
